import { FieldInput } from 'components/fieldInput';
import { Form, Formik } from 'formik';
import React, { Fragment } from 'react';
import CustomLoader from 'components/CustomLoader';
import { EndorsementsTable } from '../components/EndorsementsTable';
import styles from '../styles.module.scss';

export function AddVehicleOrTrailer({
  validation,
  endorsements,
  changes,
  loading,
  stated_value,
  handleChangeStatedValue,
  setEndorsements,
  setStage,
  submit,
  submitting,
  resetModal,
  trailersBodytype,
  vehiclesBodytype,
  classOptions
}) {
  return (
    <div className={styles.insideWrapper}>
      <div className={styles.title}>
        Add a vehicle or trailer
      </div>
      <div className={styles.line} />
      <Formik
        validationSchema={validation}
        initialValues={{
          year: '',
          make: '',
          model: '',
          value: '',
          vin: '',
          vehicle_class: 'n/a',
          vehicle_body_type: 'n/a',
          trailer_body_type: 'n/a',
        }}
      >
        {({
          errors,
          touched,
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          validateForm,
          setTouched,
        }) => (
          <Fragment>
            <Form
              className={styles.form}
              onSubmit={handleSubmit}
              style={{ marginTop: 10 }}
            >
              <div
                className={styles.fieldRow}
                style={{ marginBottom: 10 }}
              >
                <FieldInput
                  id="year"
                  type="text"
                  label="Year"
                  placeholder="Year"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.year}
                  touched={touched.year}
                  required
                />
                <FieldInput
                  id="make"
                  type="text"
                  label="Make"
                  placeholder="Make"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.make}
                  touched={touched.make}
                  required
                />
              </div>
              <div
                className={styles.fieldRow}
                style={{ marginBottom: 10 }}
              >
                <FieldInput
                  id="model"
                  type="text"
                  label="Model"
                  placeholder="Model"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.model}
                  touched={touched.model}
                  required
                />
                <FieldInput
                  id="vin"
                  type="text"
                  label="VIN"
                  placeholder="VIN"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.vin}
                  touched={touched.vin}
                  required
                />
              </div>
              <div
                className={styles.fieldRow}
                style={{ marginBottom: 10 }}
              >
                <FieldInput
                  id="value"
                  type="currency"
                  label="Value"
                  placeholder="Value"
                  handleChange={(event) => {
                    handleChangeStatedValue(
                      event,
                      handleChange
                    );
                  }}
                  value={stated_value}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.value}
                  touched={touched.value}
                  required
                />
                <FieldInput
                  id="trailer_body_type"
                  type="select"
                  label="Trailer Body Type"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.trailer_body_type}
                  touched={touched.trailer_body_type}
                  options={[
                    { value: 'n/a', label: 'N/A' },
                    ...trailersBodytype,
                  ]}
                />
              </div>
              <div
                className={styles.fieldRow}
                style={{ marginBottom: 10 }}
              >
                <FieldInput
                  id="vehicle_body_type"
                  type="select"
                  label="Vehicle Body Type"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.vehicle_body_type}
                  touched={touched.vehicle_body_type}
                  options={[
                    { value: 'n/a', label: 'N/A' },
                    ...vehiclesBodytype,
                  ]}
                />
                <FieldInput
                  id="vehicle_class"
                  type="select"
                  label="Vehicle Class"
                  placeholder="Insert vehicle's class"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.vehicle_class}
                  touched={touched.vehicle_class}
                  options={[
                    { value: 'n/a', label: 'N/A' },
                    ...classOptions,
                  ]}
                />
              </div>
            </Form>
            {endorsements.length > 0 && (
              <EndorsementsTable changes={changes} loading={loading} />
            )}
            <div
              className={styles.footer}
              style={{
                justifyContent: 'space-between',
              }}
            >
              <div className={styles.buttons}>
                <button
                  className={styles.cancel}
                  onClick={resetModal}
                >
                  Cancel
                </button>
              </div>
              <div className={styles.buttons}>
                <button
                  className={styles.save}
                  style={{
                    marginRight: 10,
                    marginLeft: 10,
                    width: '240px',
                  }}
                  onClick={async () => {
                    setTouched({
                      year: true,
                      make: true,
                      model: true,
                      vin: true,
                      value: true,
                    });

                    if (
                      values.year !== '' ||
                      values.make !== '' ||
                      values.model !== '' ||
                      values.vin !== '' ||
                      values.value !== ''
                    ) {
                      const validation = await validateForm(values);

                      if (Object.values(validation).length === 0) {
                        setEndorsements((prev) => [
                          ...prev,
                          {
                            type: 'add_vehicle_or_trailer',
                            value: {
                              ...values,
                              value: Number(
                                values.value.replaceAll(
                                  /\D/g,
                                  ''
                                )
                              ),
                            },
                          },
                        ]);

                        setStage('select_endorsement_type');
                      }
                    } else {
                      setStage('select_endorsement_type');
                    }
                  }}
                >
                  Add Another Change
                </button>
                <button
                  className={styles.save}
                  style={{ width: '330px' }}
                  onClick={async () => {
                    setTouched({
                      year: true,
                      make: true,
                      model: true,
                      vin: true,
                      value: true,
                    });

                    if (
                      values.year !== '' ||
                      values.make !== '' ||
                      values.model !== '' ||
                      values.vin !== '' ||
                      values.value !== ''
                    ) {
                      const validation = await validateForm(values);

                      if (Object.values(validation).length === 0) {
                        submit([
                          ...endorsements,
                          {
                            type: 'add_vehicle_or_trailer',
                            value: {
                              ...values,
                              value: Number(
                                values.value.replaceAll(
                                  /\D/g,
                                  ''
                                )
                              ),
                            },
                          },
                        ]);
                      }
                    } else {
                      submit(endorsements);
                    }
                  }}
                >
                  {submitting ? (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <CustomLoader />
                    </div>
                  ) : (
                    'Finish and Submit Endorsement'
                  )}
                </button>
              </div>
            </div>
          </Fragment>
        )}
      </Formik>
    </div>
  );
}
